function on(element, eventName, selector, fn) {

  element.addEventListener(eventName, (event) => {
    const targets = document.querySelectorAll(selector);

    for (let i = 0, l = targets.length; i < l; i++) {
      const t = targets[i];
      fn.call(t, event);
    }

  });
}

export {
  on
};
